import { render, staticRenderFns } from "./EditDeleteButtons.vue?vue&type=template&id=190c2f5e&"
import script from "./EditDeleteButtons.vue?vue&type=script&lang=js&"
export * from "./EditDeleteButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports